import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { FilterComponent } from './filter.component';
import { FiltersMobileModule } from '../filters-layout/filters-mobile/filters-mobile.module';
import { FiltersDesktopModule } from '../filters-layout/filters-desktop/filters-desktop.module';

@NgModule({
	declarations: [FilterComponent],
	imports: [SharedModule, FiltersMobileModule, FiltersDesktopModule],
	exports: [FilterComponent],
})
export class FilterModule {}
